import React from 'react';

interface ButtonProps {
  onClick: () => void;
  color: 'red' | 'blue' | 'yellow' | 'green' | 'gray';
  icon?: React.ReactNode;
  text: string;
  badge?: number;
  className?: string;
  variant?: 'solid' | 'status';
  isActive?: boolean;
}

const Button: React.FC<ButtonProps> = ({ 
  onClick, 
  color, 
  icon, 
  text, 
  badge,
  className = '',
  variant = 'solid',
  isActive = false
}) => {
  const colorClasses = {
    solid: {
      red: 'bg-red-500 hover:bg-red-600',
      blue: 'bg-blue-500 hover:bg-blue-600',
      yellow: 'bg-yellow-500 hover:bg-yellow-600',
      green: 'bg-green-500 hover:bg-green-600',
      gray: 'bg-gray-500 hover:bg-gray-600'
    },
    status: {
      red: isActive ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-slate-600 dark:text-gray-200 dark:hover:bg-slate-500',
      blue: isActive ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-slate-600 dark:text-gray-200 dark:hover:bg-slate-500',
      yellow: isActive ? 'bg-yellow-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-slate-600 dark:text-gray-200 dark:hover:bg-slate-500',
      green: isActive ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-slate-600 dark:text-gray-200 dark:hover:bg-slate-500',
      gray: isActive ? 'bg-gray-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-slate-600 dark:text-gray-200 dark:hover:bg-slate-500'
    }
  };

  const baseClasses = variant === 'solid' 
    ? 'w-48 h-12 text-white'
    : 'px-6 py-3';

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${colorClasses[variant][color]} rounded-xl transition-all duration-200 shadow-md hover:shadow-xl flex items-center justify-center gap-2 relative ${className}`}
    >
      {icon}
      <span className="text-center">{text}</span>
      {badge && badge > 0 && (
        <span className="absolute -top-2 -right-2 bg-white text-red-600 text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center border-2 border-red-500">
          {badge}
        </span>
      )}
    </button>
  );
};

export default Button; 